import AITimeline from './AITimeline';

function App() {
  return <AITimeline />;
}

export default App;